import type { EntitiesState } from '@redux/entities'

interface CombineAgentNamesParams {
  agentIds?: number[],
  agents: EntitiesState['agents'],
  joiningWord?: string,
}

export function combineAgentNames(params: CombineAgentNamesParams) {
  const { agentIds, agents, joiningWord = 'and' } = params

  const agentsArray = agentIds?.map(id => agents[id]).filter(a => a)
  const [leadAgent, secondAgent] = agentsArray || []

  if (leadAgent && secondAgent){
    return `${leadAgent.full_name} ${joiningWord} ${secondAgent.full_name}`
  }

  if (leadAgent){
    return leadAgent.full_name
  }

  return 'No Agents'
}

type FindUsersUsingAgentIdsParams = {
  agentIds?: number[],
  users: EntitiesState['users'],
}

export function findUsersUsingAgentIds(params: FindUsersUsingAgentIdsParams) {
  const { agentIds = [], users } = params

  if (!users || !agentIds) return []

  const array = Object.values(users)

  return agentIds.map((agentId) => {
    const user = array.find(u => u.actable_type === 'Agent' && u.actable_id === agentId)
    return user
  }).filter(u => u)
}

export default findUsersUsingAgentIds
